import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import OptimizeImagesService from 'services/OptimizeImages.service';

import styles from './NewsSmall.module.scss';

export default class NewsSmallComponent extends Component {
  static defaultProps = {
    className: ''
  };
  static propTypes = {
    pressArticle: PropTypes.object.isRequired
  };

  render() {
    const { className, pressArticle } = this.props;
    const {
      title,
      publicationDate,
      link,
      company: { logo }
    } = pressArticle;

    return (
      <div className={`${styles.NewsSmall} ${className}`}>
        <h4 className={styles.Title}>
          {link.isValid() ? (
            <a
              href={link.href}
              target="_blank"
              rel="noopener noreferrer nofollow"
            >
              {title}
            </a>
          ) : (
            title
          )}
        </h4>
        <p className={styles.Date}>
          {moment(publicationDate).format('DD.MM.YYYY')}
        </p>
        {link.isValid() && <p className={styles.URL}>{link.origin}</p>}
        <div className={styles.IMGWrapper}>
          <img src={OptimizeImagesService.adjustImageSize(logo)} alt="logo" />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/MediaAboutUs/components/NewsSmall/NewsSmall.js